import React, { PureComponent } from 'react'
import { string, number, bool, object, func, arrayOf, shape, oneOfType } from 'prop-types'

import { PreRaceWheelsCard, PitStopsCard } from 'components'
import ITEM from 'utils/constants/items'
import './SectionCards.css'

export class SubSectionPreRaceCardsGroup extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        cards: arrayOf(
            shape({
                typeId: string.isRequired,
                icon: string.isRequired,
                name: string,
                description: string,
                performanceFactor: number,
                deteriorationFactor: number,
                prices: arrayOf(number),
                priceInDebt: number,
                unitsLeftAsNormalPrice: number
            })
        ).isRequired,
        availableCredits: number.isRequired,
        selection: oneOfType([string, number]),
        onSelect: func.isRequired,
        onSelectPitStops: func.isRequired,
        showAMToolPanel: bool.isRequired,
        onToggleAMToolPanel: func.isRequired,
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }).isRequired,
        currentSelection: object.isRequired,
        numLaps: number.isRequired,
        lapLength: number.isRequired,
        allowPurchaseUnitsInDebt: bool.isRequired
    }

    componentWillMount() {
        const { cards } = this.props
        this.curvesFactors = cards.map(c => ({ y: c.performanceFactor, x: 1 / c.deteriorationFactor }))
    }

    renderCard = ({ typeId, icon, name, description, performanceFactor, deteriorationFactor, prices, priceInDebt, unitsLeftAsNormalPrice }, index) => {
        const {
            groupId,
            availableCredits,
            selection,
            onSelect,
            onSelectPitStops,
            curvesParams,
            currentSelection,
            showAMToolPanel,
            onToggleAMToolPanel,
            numLaps,
            lapLength,
            allowPurchaseUnitsInDebt
        } = this.props
        if (groupId === ITEM.PRE_RACE_PITSTOPS) {
            return (
                <PitStopsCard
                    key={typeId}
                    groupId={groupId}
                    typeId={typeId}
                    units={selection || 0}
                    maxUnits={numLaps - 1}
                    unitsLeft={currentSelection.wheels.unitsLeft - 1}
                    prices={prices}
                    availableCredits={availableCredits}
                    onSetUnits={onSelectPitStops}
                    showAMToolPanel={showAMToolPanel}
                    onToggleAMToolPanel={onToggleAMToolPanel}
                    curveParams={curvesParams.wheels}
                    performanceMax={currentSelection.wheels.performanceMax}
                    expectedAssetLife={currentSelection.wheels.expectedAssetLife}
                    circuitLength={numLaps * lapLength}
                    allowPurchaseUnitsInDebt={allowPurchaseUnitsInDebt}
                    priceInDebt={priceInDebt}
                    unitsLeftAsNormalPrice={unitsLeftAsNormalPrice}
                />
            )
        }
        const isSelected = selection === typeId
        if (groupId === ITEM.PRE_RACE_WHEELS) {
            return (
                <PreRaceWheelsCard
                    key={typeId}
                    groupId={groupId}
                    typeId={typeId}
                    icon={icon}
                    name={name}
                    description={description}
                    performanceFactor={performanceFactor}
                    deteriorationFactor={deteriorationFactor}
                    selected={isSelected}
                    onSelect={onSelect}
                    showAMToolPanel={showAMToolPanel}
                    onToggleAMToolPanel={isSelected ? onToggleAMToolPanel : null}
                    curveParams={curvesParams.wheels}
                    curvesFactors={this.curvesFactors}
                    curveIndex={index}
                    performanceMax={currentSelection.wheels.performanceMax}
                    expectedAssetLife={currentSelection.wheels.expectedAssetLife}
                />
            )
        }
        return (
            <PreRaceWheelsCard
                key={typeId}
                groupId={groupId}
                typeId={typeId}
                icon={icon}
                name={name}
                description={description}
                performanceFactor={performanceFactor}
                deteriorationFactor={deteriorationFactor}
                selected={isSelected}
                onSelect={onSelect}
                showAMToolPanel={showAMToolPanel}
                onToggleAMToolPanel={isSelected ? onToggleAMToolPanel : null}
                curveParams={curvesParams.wheels}
                curvesFactors={this.curvesFactors}
                curveIndex={index}
                performanceMax={currentSelection.wheels.performanceMax}
                expectedAssetLife={currentSelection.wheels.expectedAssetLife}
                applyDrivingStyleFactor
            />
        )
    }

    render() {
        const { groupId, cards } = this.props
        return <div className={groupId === ITEM.PRE_RACE_PITSTOPS ? 'flex row-right-center' : 'flex row-stretch-center'}>{cards.map(this.renderCard)}</div>
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Cards/SubSectionPreRaceCardsGroup.js